import { render, staticRenderFns } from "./DatasetDownload.vue?vue&type=template&id=7d32b503"
import script from "./DatasetDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetDownload.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports